export const DEFAULT_IMUM_PER_PAGE = 200
export const DEFAULT_IMUM_RULES_PER_PAGE = 25
export const DEFAULT_PER_PAGE = 50
